import Swiper, { Navigation, Lazy, Autoplay } from 'swiper';

import '../../../node_modules/swiper/swiper.min.css';
import '../../../node_modules/swiper/modules/navigation/navigation.min.css';
import '../../../node_modules/swiper/modules/lazy/lazy.min.css';

window.addEventListener('DOMContentLoaded', () => {
    Swiper.use([Navigation, Lazy, Autoplay]);

    const swiper =  new Swiper('.homepage-masthead-carousel', {
        slidesPerView: 1,
        loop: true,
        preloadImages: false,
        watchSlidesProgress: true,
        lazy: {
            checkInView: true,
            loadPrevNext: true,
            loadOnTransitionStart: true
        },
        autoplay: {
            delay: 8000
        },
        speed: 800,
        keyboard: {
            enabled: true
        },
        navigation: {
            nextEl: '.carousel-next',
            prevEl: '.carousel-prev'
        }
    })
})
